import { Button, Input } from '@material-tailwind/react'
import React from 'react'

const InvoiceDetails = ({ consigneeGST, setConsigneeGST, sellerGST, setSellerGST, invoiceDetail, setInvoiceDetail, addInvoice, invoiceDocument, addSupport, supportDocument, invoiceList, setInvoiceList }) => {
  const handleAddInvoice = () => {
    if (!invoiceDetail?.ident || !invoiceDetail?.n_value) {
      return;
    }

    setInvoiceList([...invoiceList, {
      ...invoiceDetail,
      n_value: Number(invoiceDetail.n_value)
    }])
    setInvoiceDetail({
      ident: "",
      n_value: 0,
      ewaybill: ""
    })
  }

  const removeInvoice = (invoiceNo) => {
    const index = invoiceList.findIndex((item) => item.ident === invoiceNo);
    if (index !== -1) {
      const newVariations = [...invoiceList];
      newVariations.splice(index, 1);
      setInvoiceList(newVariations);
    }
  };

  return (
    <div className='rounded-[24px] border border-slate-200 bg-white px-5 py-5 shadow-[0_18px_42px_rgba(15,23,42,0.07)]'>
      <div className='mb-5 flex flex-col gap-1 border-b border-slate-100 pb-4'>
        <h3 className='font-[GilroyBold] text-[1.1rem] text-slate-900'>Invoice Details</h3>
        <p className='text-sm font-[GilroyMedium] text-slate-500'>Attach invoice metadata, GST information, and supporting files.</p>
      </div>

      <div className='grid gap-4 md:grid-cols-2 xl:grid-cols-3 my-3'>
        <div>
          <Input type='number' value={invoiceDetail?.n_value} onChange={(e) => setInvoiceDetail({ ...invoiceDetail, n_value: e.target.value })} label='Invoice Amount' />
        </div>
        {invoiceDetail?.n_value >= 50000 && <div>
          <Input value={invoiceDetail?.ewaybill} onChange={(e) => setInvoiceDetail({ ...invoiceDetail, ewaybill: e.target.value })} label='E-Waybill' />
        </div>}
        <div>
          <Input value={invoiceDetail?.ident} onChange={(e) => setInvoiceDetail({ ...invoiceDetail, ident: e.target.value })} label='Invoice No.' />
        </div>
      </div>

      <div className='flex justify-end'>
        <Button onClick={handleAddInvoice} className='mb-1 rounded-full bg-[#f97316] px-5 py-2.5 text-xs font-[GilroyBold] text-white shadow-[0_12px_24px_rgba(249,115,22,0.22)] hover:bg-[#ea580c]'>Add Invoice</Button>
      </div>

      <div className='mt-5 overflow-hidden rounded-[20px] border border-slate-200'>
        <div className='grid bg-[#fffaf6] px-4 py-3 text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52] grid-cols-4'>
          <p>Invoice Amount</p>
          <p>E Waybill</p>
          <p>Invoice No</p>
          <p>Actions</p>
        </div>
        {invoiceList?.length ? invoiceList.map((item, index) => (
          <div key={`${item.ident}-${index}`} className='grid border-t border-slate-100 bg-white px-4 py-3 text-[13px] font-[GilroyMedium] text-slate-700 grid-cols-4'>
            <p>{item.n_value}</p>
            <p>{item.ewaybill || '-'}</p>
            <p>{item.ident}</p>
            <button type='button' onClick={() => removeInvoice(item.ident)} className='w-fit font-[GilroyBold] text-red-500'>Remove</button>
          </div>
        )) : (
          <div className='px-4 py-10 text-center text-sm font-[GilroyMedium] text-slate-400'>No invoices added yet.</div>
        )}
      </div>

      <h3 className='mt-6 text-sm font-[GilroyBold] uppercase tracking-[0.14em] text-slate-400'>GST Details</h3>
      <div className='grid gap-4 md:grid-cols-2 my-3'>
        <div>
          <Input value={sellerGST} onChange={(e) => setSellerGST(e.target.value)} label='Shipper GSTIN' />
        </div>
        <div>
          <Input value={consigneeGST} onChange={(e) => setConsigneeGST(e.target.value)} label='Consignee GSTIN' />
        </div>
      </div>

      <h3 className='mt-6 text-sm font-[GilroyBold] uppercase tracking-[0.14em] text-slate-400'>Upload Documents</h3>
      <div className='grid gap-5 md:grid-cols-2 my-3'>
        <div className='rounded-[20px] border border-slate-200 bg-slate-50 px-4 py-4'>
          <p className='font-[GilroyBold] text-sm text-slate-700 my-1'>1) Invoice</p>
          <form onSubmit={addInvoice} className='form flex items-center justify-center flex-col my-6'>
            <input type='file' />
            <Button className='my-6 rounded-full bg-slate-900 px-5 py-2.5 text-xs font-[GilroyBold]' type='submit' size="md">Upload Document</Button>
          </form>
          <p className='break-all text-xs text-black'>{invoiceDocument}</p>
        </div>
        <div className='rounded-[20px] border border-slate-200 bg-slate-50 px-4 py-4'>
          <p className='font-[GilroyBold] text-sm text-slate-700 my-1'>2) Support Document</p>
          <form onSubmit={addSupport} className='form flex items-center justify-center flex-col my-6'>
            <input type='file' />
            <Button className='my-6 rounded-full bg-slate-900 px-5 py-2.5 text-xs font-[GilroyBold]' type='submit' size="md">Upload Document</Button>
          </form>
          <p className='break-all text-xs text-black'>{supportDocument}</p>
        </div>
      </div>
    </div>
  )
}

export default InvoiceDetails
